import {
  GuideCompletionMethod,
  GuideSource,
  GuideStepKey,
  LatestOnboardingSessionResponse,
  OnboardingGuideResponse
} from '../types/OnboardingGuide.types';
import API from './ApiBase';

export const startOnboarding = async (
  source: GuideSource
): Promise<OnboardingGuideResponse> => {
  try {
    const response = await API.post<OnboardingGuideResponse>(
      '/user-onboarding/start',
      {
        source
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to start onboarding guide'
    );
  }
};

export const getLatestOnboardingSession =
  async (): Promise<LatestOnboardingSessionResponse> => {
    try {
      const response = await API.get<OnboardingGuideResponse>(
        '/user-onboarding/latest',
        {
          skipErrorToast: true
        } as any
      );

      return {
        status: 200,
        data: response.data
      };
    } catch (error: any) {
      if (error.response?.status === 404) {
        return {
          status: 404,
          data: null
        };
      }

      throw new Error(
        error.response?.data?.message ||
          'Failed to fetch latest onboarding session'
      );
    }
  };

export const dismissBanner = async (): Promise<OnboardingGuideResponse> => {
  try {
    const response = await API.patch<OnboardingGuideResponse>(
      '/user-onboarding/banner/dismiss'
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to dismiss onboarding banner'
    );
  }
};

export const changeOnboardingStep = async (
  sessionId: string,
  stepKey: GuideStepKey
): Promise<OnboardingGuideResponse> => {
  try {
    const response = await API.patch<OnboardingGuideResponse>(
      `/user-onboarding/${sessionId}/step`,
      {
        step: stepKey
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to change onboarding step'
    );
  }
};

export const abandOnboarding = async (
  id: string
): Promise<OnboardingGuideResponse> => {
  try {
    const response = await API.patch<OnboardingGuideResponse>(
      `/user-onboarding/${id}/abandon`
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to abandon onboarding guide'
    );
  }
};

export const completeOnboarding = async (
  id: string,
  method: GuideCompletionMethod
): Promise<OnboardingGuideResponse> => {
  try {
    const response = await API.patch<OnboardingGuideResponse>(
      `/user-onboarding/${id}/complete`,
      {
        completionMethod: method
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Failed to complete onboarding guide'
    );
  }
};
